import axios from 'axios'
import { sessionStore } from '../reducers'

const authentication = {

  isAuthenticated () {
    const token = localStorage.getItem('token')
    if (sessionStore.getState().loggedIn)
      return new Promise(function(resolve, reject){ resolve() })
    else if(token) {
      return axios.get('https://api.psyco.fr/cafe/session', {headers: {'Authorization': token}})
    } else {
      return new Promise(function(resolve, reject){ reject() })
    }
  },

  login (username, password, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/session', {username: username,
                                                                    password: password})
    this.handleAuth(promise, cb)
  },

  register (username, password, passwordConfirmation, keys, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/users', {username: username,
                                                                  password: password,
                                                                  passwordConfirmation: passwordConfirmation,
                                                                  keys: keys})
    this.handleAuth(promise, cb)
  },

  validateRecaptcha (response, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/recaptcha',
      { 'response': response },
      {'headers':
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  update (username, password, passwordConfirmation, keys, cb) {
    const promise = axios.patch('https://api.psyco.fr/cafe/users', {username: username,
                                                                   password: password,
                                                                   passwordConfirmation: passwordConfirmation,
                                                                   keys: keys})
    this.handleAuth(promise, cb)
  },

  delete (username, cb) {
    const token = localStorage.getItem('token')
    const promise = axios.delete('https://api.psyco.fr/cafe/users', {headers: {'Authorization': token}})
    localStorage.clear()
    sessionStore.dispatch({'type': 'UNLOGGED'})
    this.handleRequest(promise, cb)
  },

  logout () {
    const token = localStorage.getItem('token')
    axios.delete('https://api.psyco.fr/cafe/session', {headers: {'Authorization': token}})
    localStorage.clear()
    sessionStore.dispatch({'type': 'UNLOGGED'})
    return true
  },

  handleAuth (promise, cb) {
    promise.then((resp) => {
      if (resp.data.token && resp.data.username) {
        sessionStore.dispatch({'type': 'LOGGED'})
        localStorage.setItem('token', resp.data.token)
        localStorage.setItem('username', resp.data.username)
        cb(true)
      }
    }).catch((error) => cb(false))
  },

  handleRequest (promise, cb) {
    promise.then((resp) => {
      cb(true)
    }).catch((error) => cb(false))
  },
}

export default authentication



// WEBPACK FOOTER //
// ./src/http/auth.js